//must be same as in schema!!!
export const Switches = {
  debugQuiz: false,
  debugQuizEmail: "a@test.se",
  userCandisableItself: false, //Todo: somewhat tricky to implement.
};
